import {gsap, SplitText, ScrollTrigger} from "../LibrariesImport";
export default class ImageAppear {

	static init(){

		let images = document.querySelectorAll('.image-appear');

		images.forEach( (image) => {

			let mediaLayout = image.closest('[data-layout]');
			let propsMedia = window.getComputedStyle(mediaLayout);
			let paddingMedia = propsMedia.getPropertyValue("padding-left");

			let dataLayout = mediaLayout.previousElementSibling;
			let props = window.getComputedStyle(dataLayout);
			let padding = props.getPropertyValue("padding-left");

			let newPadding = parseFloat(padding) - parseFloat(paddingMedia);

			this.bannerAnimation = gsap.fromTo(image, {
				clipPath: `inset(0px ${newPadding}px ${newPadding*2}px ${newPadding}px round 10px)`,
				overwrite: true
			},
			{
				clipPath: `inset(0px 0px ${newPadding}px 0px round 10px)`,
				scrollTrigger: {
					trigger: image,
					start: 'top 75%',
					end: 'bottom 85%',
					scrub: 1,
					overwrite: true
				}
			});

		});

	}

}